var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3979 11.7988L12.0028 6.58895",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90681 19.5683L9.90585 20.3183C10.1101 20.3186 10.3056 20.2355 10.4472 20.0884L9.90681 19.5683ZM4.50304 14.3674L3.96267 13.8473C3.82105 13.9945 3.74556 14.193 3.75363 14.3971L4.50304 14.3674ZM4.70849 19.5617L3.95908 19.5913L3.98753 20.3107L4.70753 20.3117L4.70849 19.5617ZM14.6892 5.22602L18.6519 9.04001L19.6921 7.95926L15.7294 4.14526L14.6892 5.22602ZM18.6587 9.3935L9.36643 19.0482L10.4472 20.0884L19.7395 10.4337L18.6587 9.3935ZM5.04342 14.8875L14.3357 5.23278L13.2549 4.1926L3.96267 13.8473L5.04342 14.8875ZM9.90776 18.8183L4.70945 18.8117L4.70753 20.3117L9.90585 20.3183L9.90776 18.8183ZM5.45791 19.532L5.25246 14.3378L3.75363 14.3971L3.95908 19.5913L5.45791 19.532ZM18.6519 9.04001C18.7514 9.13576 18.7544 9.29402 18.6587 9.3935L19.7395 10.4337C20.4097 9.73732 20.3885 8.62948 19.6921 7.95926L18.6519 9.04001ZM15.7294 4.14526C15.033 3.47504 13.9252 3.49624 13.2549 4.1926L14.3357 5.23278C14.4314 5.1333 14.5897 5.13027 14.6892 5.22602L15.7294 4.14526Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5996H13",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/edit-pencil-icon.c7403aafeadd231587d49ed1ba002c18.svg";
export { ForwardRef as ReactComponent };